module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.9947/images/hubspot-academy-logo-color.svg"